export type SHLDivision = "North" | "South";

export interface SHLTeam {
  id: string;
  name: string;
  nameSv: string;
  abbr: string;
  city: string;
  logo: string;
  division: SHLDivision;
}

// SHL team logos from TheSportsDB
const SHL_LOGOS: Record<string, string> = {
  "lulea": "https://r2.thesportsdb.com/images/media/team/badge/8jl0kk1656774414.png",
  "skelleftea": "https://r2.thesportsdb.com/images/media/team/badge/5l2p5c1656774702.png",
  "brynas": "https://r2.thesportsdb.com/images/media/team/badge/s0lnxq1656774367.png",
  "modo": "https://r2.thesportsdb.com/images/media/team/badge/wpvvyr1421609878.png",
  "timra": "https://r2.thesportsdb.com/images/media/team/badge/h9a1sd1656774723.png",
  "orebro": "https://r2.thesportsdb.com/images/media/team/badge/ycg4xj1656774656.png",
  "farjestad": "https://r2.thesportsdb.com/images/media/team/badge/rg9dfe1656774459.png",
  "djurgarden": "https://r2.thesportsdb.com/images/media/team/badge/i58zfb1656774438.png",
  "frolunda": "https://r2.thesportsdb.com/images/media/team/badge/1zbgup1656774483.png",
  "vaxjo": "https://r2.thesportsdb.com/images/media/team/badge/0w7o3d1656774746.png",
  "rogle": "https://r2.thesportsdb.com/images/media/team/badge/b8fwz31656774681.png",
  "malmo": "https://r2.thesportsdb.com/images/media/team/badge/jh5hxp1656774528.png",
  "hv71": "https://r2.thesportsdb.com/images/media/team/badge/3x7sxj1656774505.png",
  "linkoping": "https://r2.thesportsdb.com/images/media/team/badge/6r3f6j1656774559.png",
};

const getSHLLogo = (teamId: string) => SHL_LOGOS[teamId] ?? "";

export const SHL_TEAMS: SHLTeam[] = [
  // North Division
  { id: "lulea", name: "Luleå HF", nameSv: "Luleå HF", abbr: "LHF", city: "Luleå", logo: getSHLLogo("lulea"), division: "North" },
  { id: "skelleftea", name: "Skellefteå AIK", nameSv: "Skellefteå AIK", abbr: "SKE", city: "Skellefteå", logo: getSHLLogo("skelleftea"), division: "North" },
  { id: "brynas", name: "Brynäs IF", nameSv: "Brynäs IF", abbr: "BIF", city: "Gävle", logo: getSHLLogo("brynas"), division: "North" },
  { id: "modo", name: "MODO Hockey", nameSv: "MODO Hockey", abbr: "MHF", city: "Örnsköldsvik", logo: getSHLLogo("modo"), division: "North" },
  { id: "timra", name: "Timrå IK", nameSv: "Timrå IK", abbr: "TIK", city: "Timrå", logo: getSHLLogo("timra"), division: "North" },
  { id: "orebro", name: "Örebro Hockey", nameSv: "Örebro Hockey", abbr: "ÖRE", city: "Örebro", logo: getSHLLogo("orebro"), division: "North" },
  { id: "farjestad", name: "Färjestad BK", nameSv: "Färjestad BK", abbr: "FBK", city: "Karlstad", logo: getSHLLogo("farjestad"), division: "North" },

  // South Division
  { id: "djurgarden", name: "Djurgårdens IF", nameSv: "Djurgårdens IF", abbr: "DIF", city: "Stockholm", logo: getSHLLogo("djurgarden"), division: "South" },
  { id: "frolunda", name: "Frölunda HC", nameSv: "Frölunda HC", abbr: "FHC", city: "Gothenburg", logo: getSHLLogo("frolunda"), division: "South" },
  { id: "vaxjo", name: "Växjö Lakers", nameSv: "Växjö Lakers", abbr: "VLH", city: "Växjö", logo: getSHLLogo("vaxjo"), division: "South" },
  { id: "rogle", name: "Rögle BK", nameSv: "Rögle BK", abbr: "RBK", city: "Ängelholm", logo: getSHLLogo("rogle"), division: "South" },
  { id: "malmo", name: "Malmö Redhawks", nameSv: "Malmö Redhawks", abbr: "MRH", city: "Malmö", logo: getSHLLogo("malmo"), division: "South" },
  { id: "hv71", name: "HV71", nameSv: "HV71", abbr: "HV71", city: "Jönköping", logo: getSHLLogo("hv71"), division: "South" },
  { id: "linkoping", name: "Linköpings HC", nameSv: "Linköpings HC", abbr: "LHC", city: "Linköping", logo: getSHLLogo("linkoping"), division: "South" },
];

export const SHL_DIVISIONS: SHLDivision[] = ["North", "South"];

export const getSHLTeamByAbbr = (abbr: string): SHLTeam | undefined => {
  return SHL_TEAMS.find((team) => team.abbr === abbr);
};

export const getSHLTeamsByDivision = (division: SHLDivision): SHLTeam[] => {
  return SHL_TEAMS.filter((team) => team.division === division);
};